import React from "react";
// import { Link } from "react-router-dom";
// import Image1 from "../../images/Image1.jpg";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import VideoEmbed from "../ui/VideoEmbed";
// import SplitStorySection from "../ui/SplitStorySection";
import FadeIn from "../ui/FadeIn";

const timelineData = [
  {
    period: "Mid-2000s",
    title: "The Seed of an Idea",
    content: "Late Mr. Vasant Kalbag, a Mumbai-based retired businessman and scientist, researched 'Why Kindness Matters.' He discovered that human reciprocity thrives on conscious, random acts of kindness, supported by evolutionary theories of cooperation.",
    video: "https://www.youtube.com/embed/9_7b4UoioL4",
    videoTitle: "Our Story"
  },
  {
    period: "2005",
    title: "Kindness Unlimited is Born",
    content: "Mr. Vasant and Mrs. Shanti Kalbag, along with founder trustee Mrs. Nirmala Peters Mehendale, formalized KU. The movement started with a simple belief: nothing is more unkind than hoarding privileges when others are in misery.",
    video: "https://www.youtube.com/embed/BTtYaDbs0Bk",
    videoTitle: "Behind Our Logo - Kindness Unlimited"
  },
  {
    period: "The Journey",
    title: "Building the Pillars of Kindness",
    content: "Over two decades, we've organized multiple causes to create a snowball effect of kindness. We operate on two pillars: Self-interest + Common Good. We firmly believe kindness begins with self-care to avoid exhaustion and resentment.",
    video: "https://www.youtube.com/embed/Floq0FkcEEs",
    videoTitle: "Worldwide Dance for Kindness - Mumbai"
  },
  {
    period: "Present Day",
    title: "Going Global",
    content: "Today, KU is an executive member of the World Kindness Movement (WKM), a global body representing 28 countries with no religious or political affiliations, fostering goodwill and cooperation worldwide.",
    video: "https://www.youtube.com/embed/9cMvQSC3dgo",
    videoTitle: "Spread Kindness - it's Contagious"
  },
  {
    period: "The Future",
    title: "Transforming India into KINDia",
    content: "We aspire to shift the global mindset from 'ME to WE.' Our ultimate dream is to make kindness prudent, practical, and sustainable, turning every unkind situation into an opportunity for empathy.",
  }
];

const OurStory = () => (
  <PageLayout>
    <PageHero title="Our Story" eyebrow="Since 2005" light />

    {/* Timeline Section */}
    <section className="ku-section bg-slate-50 py-24">
      <div className="ku-container max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col">
          
          {timelineData.map((item, index) => {
            // Check if this is the last item so we can cleanly stop the line
            const isLast = index === timelineData.length - 1;

            return (
              <FadeIn key={index}>
                {/* Using flex layouts ensures the timeline graphic column 
                  and the card column are always the exact same height.
                  pb-16 creates the gap between cards.
                */}
                <div className={`flex items-stretch ${isLast ? '' : 'pb-16'}`}>
                  
                  {/* Left Column: Timeline Graphic */}
                  <div className="relative w-6 shrink-0 mr-6 md:mr-10">
                    
                    {/* The Timeline Dot
                      top-[44px] vertically aligns with the center of the period pill.
                      left-0 perfectly fills the w-6 container.
                    */}
                    <div className="absolute top-[44px] left-0 h-6 w-6 rounded-full bg-gradient-to-br from-purple-500 to-purple-800 border-4 border-white shadow-md z-10"></div>
                    
                    {/* The Line Segment (Hidden on last item to prevent poking out)
                      top-[56px] starts perfectly hidden behind the center of the current dot.
                      bottom-[-56px] stretches exactly to the center of the NEXT dot.
                      left-[10px] over a w-1 perfectly centers it horizontally.
                    */}
                    {!isLast && (
                      <div className="absolute top-[56px] bottom-[-56px] left-[10px] w-1 bg-purple-200 z-0"></div>
                    )}
                  </div>

                  {/* Right Column: Content Card */}
                  <div className="flex-1">
                    <div className="bg-white rounded-2xl py-10 px-8 md:px-12 shadow-sm border border-purple-50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col items-start">
                      
                      {/* Period Pill - h-8 locks vertical alignment math */}
                      <span className="inline-flex items-center h-8 px-4 rounded-full bg-purple-100 text-sm font-bold tracking-widest text-purple-800 uppercase mb-6">
                        {item.period}
                      </span>
                      
                      <h3 className="text-3xl font-display font-bold text-gray-900 mb-6 text-left w-full">
                        {item.title}
                      </h3>
                      
                      <p className="text-lg text-gray-600 leading-relaxed mb-8 text-left w-full">
                        {item.content}
                      </p>
                      
                      {/* Embedded Video */}
                      {item.video && (
                        <div className="w-full mt-2 rounded-xl overflow-hidden border border-purple-100 shadow-sm">
                          <VideoEmbed src={item.video} title={item.videoTitle} />
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </FadeIn>
            );
          })}
          
        </div>
      </div>
    </section>
  </PageLayout>
);

export default OurStory;